import { Link } from "react-router-dom";
import useSeo, { buildBreadcrumb } from "../lib/useSeo";

export default function Terminos() {
  useSeo({
    title: "Términos y Condiciones · DoSoft",
    description: "Términos y condiciones de uso del sitio dosoft.cl y de los servicios de DoSoft Ingeniería de Software.",
    canonical: "https://dosoft.cl/terminos",
    jsonLd: [
      buildBreadcrumb([
        { name: "Inicio", url: "/" },
        { name: "Términos", url: "/terminos" },
      ]),
    ],
  });
  return (
    <div data-testid="terminos-page" className="py-16 md:py-24">
      <div className="max-w-3xl mx-auto px-6 md:px-12">
        <div className="text-xs uppercase tracking-widest text-brand font-mono mb-6">
          Legal
        </div>
        <h1 className="font-display font-black text-5xl md:text-6xl tracking-tighter text-ash-100 leading-[0.95] mb-4">
          Términos y Condiciones
        </h1>
        <p className="text-ash-300 text-sm font-mono mb-12">
          Última actualización: Mayo 2026
        </p>

        <div className="space-y-10 text-ash-100 leading-relaxed">
          <Section title="1. Aceptación">
            <p>
              Al utilizar esta plataforma aceptas estos Términos y nuestra{" "}
              <Link to="/privacidad" className="text-brand hover-line">Política de Privacidad</Link>.
              Si no estás de acuerdo con alguna parte, te pedimos no continuar usando
              el sitio.
            </p>
          </Section>

          <Section title="2. Servicios">
            <p>
              DoSoft Ingeniería de Software es una Software Factory que diseña,
              construye y mantiene aplicaciones web, móviles y software a medida para
              empresas. Esta plataforma sirve como vitrina comercial y canal de
              contacto con potenciales clientes.
            </p>
          </Section>

          <Section title="3. Uso de la plataforma">
            <p>
              Te comprometes a usar la plataforma de forma lícita y a entregar
              información veraz al completar cualquier formulario. DoSoft se reserva el
              derecho de rechazar solicitudes que contengan información falsa o que
              sean utilizadas con fines distintos a la contratación de servicios.
            </p>
          </Section>

          <Section title="4. Cotizaciones y propuestas">
            <p>
              Las cotizaciones generadas a través de la plataforma son referenciales y
              no constituyen oferta vinculante hasta la firma de un contrato de
              prestación de servicios. La propuesta comercial formal tiene la validez
              indicada en el documento PDF generado por DoSoft.
            </p>
          </Section>

          <Section title="5. Propiedad intelectual">
            <p>
              Todo el contenido de esta plataforma (textos, código, diseño, marca,
              imágenes) es propiedad de DoSoft y está protegido por la Ley de
              Propiedad Intelectual de Chile. Está prohibida su reproducción total o
              parcial sin autorización escrita.
            </p>
            <p>
              Los productos y sistemas desarrollados para clientes se regirán por los
              contratos específicos que se firmen, donde se define la titularidad del
              software entregado.
            </p>
          </Section>

          <Section title="6. Responsabilidad">
            <p>
              DoSoft no será responsable por daños indirectos, lucro cesante o pérdida
              de oportunidad derivados del uso de esta plataforma informativa.
              Cualquier responsabilidad respecto a un proyecto contratado se regirá
              por el contrato específico que ambas partes firmen.
            </p>
          </Section>

          <Section title="7. Disponibilidad">
            <p>
              Hacemos esfuerzos razonables para mantener la plataforma disponible 24/7,
              pero no garantizamos disponibilidad ininterrumpida. Podemos realizar
              mantenciones programadas o ajustes técnicos cuando sea necesario.
            </p>
          </Section>

          <Section title="8. Privacidad y datos personales">
            <p>
              El tratamiento de tus datos personales se rige por nuestra{" "}
              <Link to="/privacidad" className="text-brand hover-line">Política de Privacidad</Link>{" "}
              y cumple con la Ley N° 21.719 de Chile.
            </p>
          </Section>

          <Section title="9. Modificaciones">
            <p>
              DoSoft puede modificar estos Términos en cualquier momento. Las
              modificaciones rigen desde su publicación en esta página. El uso
              continuado de la plataforma implica aceptación de los términos
              actualizados.
            </p>
          </Section>

          <Section title="10. Ley aplicable y jurisdicción">
            <p>
              Estos Términos se rigen por las leyes de la República de Chile.
              Cualquier controversia será sometida a los tribunales ordinarios de
              justicia de la ciudad de Santiago.
            </p>
          </Section>

          <Section title="11. Contacto">
            <p>
              Para consultas sobre estos Términos, contáctanos desde el{" "}
              <Link to="/contacto" className="text-brand hover-line">formulario de contacto</Link>.
            </p>
          </Section>
        </div>
      </div>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <section>
      <h2 className="font-display font-bold text-xl text-ash-100 mb-3 border-b border-ink-500 pb-2">{title}</h2>
      <div className="text-ash-100 space-y-3">{children}</div>
    </section>
  );
}
